module.exports = __webpack_public_path__ + "img/ne.1452f3dc.svg";